/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfOrder } from '../models/data-page-of-order';
import { orderList } from '../fn/order/order-list';
import { OrderList$Params } from '../fn/order/order-list';

@Injectable({ providedIn: 'root' })
export class OrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderList()` */
  static readonly OrderListPath = '/order/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderList()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderList$Response(params?: OrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfOrder>> {
    return orderList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderList(params?: OrderList$Params, context?: HttpContext): Observable<DataPageOfOrder> {
    return this.orderList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfOrder>): DataPageOfOrder => r.body)
    );
  }

}
